import React from "react";
import { AiOutlineReload } from "react-icons/ai";

export const PrimaryButton = ({
  onClick,
  buttonName,
  icon,
  color,
  type,
  padding,
  rounded,
  width,
}) => {
  return (
    <button
      style={{ backgroundColor: color ?? "#FF6B00" }}
      className={`flex justify-center gap-1 whitespace-nowrap h-12 ${
        width ? width : "w-full"
      } items-center md:${padding ? `px-${padding}` : "px-6"} lg:${
        padding ? `px-${padding}` : "px-6"
      }   px-10 py-2 ${
        rounded ? `rounded-${rounded}` : "rounded-full"
      }  text-white focus:outline-none`}
      type={type ?? "button"}
      onClick={onClick}
    >
      <span
        className={`md:${icon ? "ml-2" : "ml-0"} lg:${icon ? "ml-2" : "ml-0"} ${
          icon ? "ml-1" : "ml-0"
        } md:text-base lg:text-base text-base`}
      >
        {buttonName}
      </span>
      <div className="md:text-xl  lg:text-xl text-lg">{icon}</div>
    </button>
  );
};

export const OutLinedHoverButton = ({
  onClick,
  buttonName,
  onDoubleClick,
  borderColor,
  textColor,
}) => {
  return (
    <button
      className={
        "flex items-center md:px-6 lg:px-6  md:py-2 lg:py-2 px-4 py-2 border rounded-lg hover:bg-primary hover:text-white focus:outline-none tc8:-mt-8 tc11:-mt-4 tc12:-mt-4 tc13:-mt-4 " +
        `border-${borderColor}` +
        `${textColor ? ` text-${textColor}` : " text-primary"}`
      }
      onClick={onClick}
      onDoubleClick={onDoubleClick}
    >
      <span>{buttonName}</span>
    </button>
  );
};
